import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");

  // ✅ LOGIN USING MYSQL (PHP API)
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setMsg("");

    if (!email || !password) {
      setError("Email and password required");
      return;
    }

    try {
      const res = await fetch(
        'https://laturelectronics.in/smartagri_api/login.php',
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`,
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        localStorage.setItem("smartagri_logged_in", "true");
        localStorage.setItem("smartagri_user_email", email);
        navigate("/home");
      } else {
        setError(data.message || "Invalid email or password");
      }
    } catch (err) {
      console.error(err);
      setError("Server error. Try again.");
    }
  };

  // ✅ FORGOT PASSWORD (EMAIL RESET LINK)
  const handleForgotPassword = async () => {
    setError("");
    setMsg("");

    if (!email) {
      setError("Please enter your email first.");
      return;
    }

    try {
      const res = await fetch(
        "https://laturelectronics.in/smartagri_api/forgot_password.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        setMsg("Password reset link sent to your email.");
      } else {
        setError(data.message || "Unable to send reset link.");
      }
    } catch (err) {
      console.error(err);
      setError("Server error. Try again.");
    }
  };

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        {/* LOGO */}
        <img src="/logo.png" alt="logo" style={styles.logo} />

        <h2 style={styles.title}>Smart Agri Login</h2>

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="Email"
            style={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {/* PASSWORD FIELD */}
          <div style={{ position: "relative" }}>
            <input
              type={showPass ? "text" : "password"}
              placeholder="Password"
              style={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <span
              onClick={() => setShowPass(!showPass)}
              style={styles.showHide}
            >
              {showPass ? "Hide" : "Show"}
            </span>
          </div>

          {error && <p style={styles.error}>{error}</p>}
          {msg && <p style={styles.success}>{msg}</p>}

          <button type="submit" className="login-btn" style={styles.button}>
            Login
          </button>
        </form>

        <p onClick={handleForgotPassword} style={styles.forgot}>
          Forgot Password?
        </p>
      </div>
    </div>
  );
};

/* -------------------- STYLES (UNCHANGED) -------------------- */

const styles = {
  bg: {
    width: "100%",
    height: "100vh",
    backgroundImage: "url('/bg1.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  card: {
    width: "350px",
    background: "rgba(0, 0, 0, 0.55)",
    backdropFilter: "blur(8px)",
    padding: "30px",
    borderRadius: "15px",
    textAlign: "center",
    boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
    border: "1px solid rgba(255,255,255,0.2)",
  },

  logo: {
    width: "80px",
    marginBottom: "10px",
  },

  title: {
    marginBottom: "20px",
    fontSize: "26px",
    fontWeight: "bold",
    color: "#fff",
  },

  form: {
    display: "flex",
    flexDirection: "column",
  },

  input: {
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "none",
    fontSize: "16px",
    outline: "none",
    background: "rgba(255,255,255,0.9)",
    width: "100%",
  },

  showHide: {
    position: "absolute",
    right: "12px",
    top: "13px",
    cursor: "pointer",
    fontWeight: "600",
    color: "#007bff",
    fontSize: "14px",
  },

  button: {
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "#00c853",
    color: "white",
    fontSize: "18px",
    cursor: "pointer",
  },

  error: {
    color: "red",
    marginBottom: "10px",
  },

  success: {
    color: "lightgreen",
    marginBottom: "10px",
  },

  forgot: {
    marginTop: "10px",
    color: "#a8ff60",
    cursor: "pointer",
    fontSize: "15px",
    textDecoration: "underline",
  },
};

export default Login;
